import script from "./Accent.vue?vue&type=script&setup=true&lang=js"
export * from "./Accent.vue?vue&type=script&setup=true&lang=js"

import "./Accent.vue?vue&type=style&index=0&id=68c2e77b&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68c2e77b"]])

export default __exports__